module.exports = {
  theme: {
    mainsubcategorysbackground: "#192040",
    btnmainbackground: "#cfd7f7",
    btnmaintext: "#192040",
    btnsecondbackground: "#2b3667",
    btnsecondtext: "#cfd7f7",
    btnthirdbackground: "#cfd7f7",
    btnthirdtext: "#000",
    btnthirdicon: "#CFD7F7",
    btnoutlineborder: "#2b3667",
    btnoutlinebackground: "#192040",
    btnoutlinetext: "#CFD7F7",
    btnoutlineicon: "#CFD7F7",
    btnoutlineactiveborder: "#CFD7F7",
    btnoutlineactivebackground: "#2b3667",
    btnoutlineactivetext: "#CFD7F7",
    btnoutlineactiveicon: "#CFD7F7",
    btndestructivebackground: "#FEE3E3",
    btndestructivetext: "#F86262",
    btndestructiveicon: "#FBA2A2",
    bordermain: "#2B3667",
    borderonbackground: "#CFD7F7",
    backgroundmain: "#000000",
    backgroundmodal: "#00000030",
    backgroundmodallayover: "#00000030",
    listsborder: "",
    listsbackground: "#FFFFFF",
    liststext: "#FFF",
    listscheckbackground: "#CFD7F7",
    listscheckborder: "#CFD7F7",
    listscheckicon: "#192040",
    listactiveprice: "#9D9D9D",
    listactivepricetext: "#ffffff",
    listsactivebackground: "#000",
    listsactivetext: "#FFF",
    listsactivecheckbackground: "#192040",
    listsactivecheckborder: "#192040",
    listsactivecheckicon: "#CFD7F7",

    text: "#dfb780",
    titlemain: "#FFFFFF",
    titlesecondary: "#CFD7F7",
    titlethird: "#CFD7F7",
    processtekst: "#FFFFFF",
    inputbackground: "#2b3667",
    inputborder: "#cfd7f7",
    paymentloadingbackground: "#2b3667",
    buttonimgcolors: "#000000",
    selectitemcolor: "#FFFFFF",
    itembackground: "#2b3667",
    thanksyouimgcolor: "#627EF8",

    cardmainbackground: "#2B3667",
    cardsecondarybackground: "#000000",
    paymentbtnbackground: "#000",
    paymentbtntext: "#FFFFFF",
    paymentfloatactivebackground: "#192040",
    tipsfloatbackground: "#2B3667",
    tabsbackground: "#2B3667",
    tabstext: "#CFD7F7",
    tabsactivebackground: "#CFD7F7",
    tabsactivetext: "#cfd7f7",
    tabsicon: "#FFFFFF",
    summbackground: "#2B3667",
    summchildrenbackground: "#F8FAFF",
    stepsbackground: "#2b3667",
    stepstext: "#FFFFFF",
    stepsnumber: "#cfd7f7",
    stepsline: "#2B3667",
    stepsactivebackground: "#99adff",
    stepsactivetext: "#FFFFFF",
    stepsactivenumber: "#FFFFFF",
    timeslotactivecolor: "#404040",

    // Discount
    discountbtnbackgroundcolor: "#F68484",
    discountlistbackgroundcolor: "#fdeded",
    discountwarningcolor: "#F68484",
    discountwarningaccentcolor: "#F68484",
    discountlistitemvaluecolor: "#c04d2e",
    discountlistitemdeletebuttonbackgroundcolor: "#fee3e3",
    discountlistitemdeletebuttoniconcolor: "#fba2a2",
    discountappliedtotalcolor: "#f68484",
  },
};
